export const isMyMusicEnabled = () =>
  process.env.REACT_APP_MY_MUSIC === 'enabled';

export const isBillingEnabled = () =>
  process.env.REACT_APP_SHOW_BILLING === true;
